import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { TIMEOUT_AXIOS_REQUEST } from 'common/constants';
import { store } from 'v3/data/store';
import { decrementLoadingCount, incrementLoadingCount } from 'v3/data/store/loading/actions';
import { setCookiesToHeaders } from 'v3/services/utils/set-cookies-to-headers';

const IS_PROXY = import.meta.env.VITE_IS_PROXY === 'true';
const BASE_URL = IS_PROXY
  ? import.meta.env.VITE_FINANCING_API_BASE_URL_PROXY_REVERSE
  : import.meta.env.VITE_FINANCING_API_BASE_URL;

const api = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT_AXIOS_REQUEST,
});

api.interceptors.response.use(
  (response: AxiosResponse) => {
    if (!response.config.metadata?.bypassLoading) decrementLoadingCount();
    return response;
  },
  (error) => {
    if (!error.config?.metadata?.bypassLoading) decrementLoadingCount();
    return Promise.reject(error);
  },
);

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const { storeUserId } = store.getState().store.storeSelected;
    config.headers['storeId'] = storeUserId;
    const bypassLoading = Boolean(config.headers?.['x-bypass-loading']);
    config.metadata = { bypassLoading };

    if (!bypassLoading) {
      incrementLoadingCount();
    }
    return setCookiesToHeaders(config);
  },
  (error) => {
    if (!error.config?.metadata?.bypassLoading) decrementLoadingCount();
    return Promise.reject(error);
  },
);

export default api;
